import React, { useState } from 'react';
import '../css/recentReplaceMedia.css';

/* ── Types ───────────────────────────────────────────────── */

export interface RecentReplaceMediaProps {
  imageSrc:  string;
  fileName:  string;
  fileSize:  string;
  onDelete?: (e?: React.MouseEvent) => void;
}

/* ── Component ───────────────────────────────────────────── */

const RecentReplaceMedia: React.FC<RecentReplaceMediaProps> = ({
  imageSrc,
  fileName,
  fileSize,
  onDelete,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div //NOSONAR
      className={`scl--cms-components-recentReplaceMedia-row${hovered ? ' hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Avatar / Thumbnail */}
      <div className="scl--cms-components-recentReplaceMedia-avatar">
        <img
          src={imageSrc}
          alt={fileName}
          className="scl--cms-components-recentReplaceMedia-img"
        />
      </div>

      {/* Text */}
      <div className="scl--cms-components-recentReplaceMedia-text">
        <span className="scl--cms-components-recentReplaceMedia-name">{fileName}</span>
        <span className="scl--cms-components-recentReplaceMedia-size">{fileSize}</span>
      </div>

      {/* Delete button — only visible on hover */}
      <button
        type="button"
        className="scl--cms-components-recentReplaceMedia-deleteBtn"
        onClick={(e) => onDelete?.(e)}
        aria-label="Delete file"
      >
        {/* Trash icon — inline SVG matching Figma spec */}
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="scl--cms-components-recentReplaceMedia-trashIcon"
        >
          {/* lid */}
          <path
            d="M1 2.5h9"
            stroke="#FE566B"
            strokeWidth="1"
            strokeLinecap="round"
          />
          {/* handle */}
          <path
            d="M3.5 2.5V1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1"
            stroke="#FE566B"
            strokeWidth="1"
            strokeLinecap="round"
          />
          {/* body */}
          <path
            d="M2 2.5l.667 7c.028.3.28.5.583.5h4.5c.303 0 .555-.2.583-.5L9 2.5"
            stroke="#FE566B"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* inner lines */}
          <path d="M4 4.5v3.5" stroke="#FE566B" strokeWidth="1" strokeLinecap="round" />
          <path d="M5.5 4.5v3.5" stroke="#FE566B" strokeWidth="1" strokeLinecap="round" />
          <path d="M7 4.5v3.5" stroke="#FE566B" strokeWidth="1" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
};

export default RecentReplaceMedia;